import * as formik from 'formik';
import * as fabric from 'office-ui-fabric-react';
import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import * as api from '../../../../../api/generated';
import { KendoLoading } from '../../../../../components';
import { ISettings } from '../GeneralSettingsPage';

interface IProps {
    settings: ISettings | null;
    fetchData: Function;
}
const validationSchema = Yup.object<ISettings>().shape({
    deptAppliesFromValue: Yup.number().required('Šis laukas yra privalomas').positive('Skaičius privalo būti teigiamas')
});

const GeneralSettingsDebts: FC<IProps> = (props) => {
    const { organizationInformationId } = useParams<'organizationInformationId'>();

    const handleSubmit = async (values: ISettings, formikActions: formik.FormikHelpers<ISettings>) => {
        formikActions.setStatus();
        try {
            await api.administration.updateOrganizationActiveTicketPrintingTimes({ id: parseInt(organizationInformationId.toString()), ...values });
            toast.success('Nustatymai sėkmingai išsaugoti');
        } catch (ex) {
            formikActions.setStatus(ex);
            toast.error(ex.error[0]);
        } finally {
            formikActions.setSubmitting(false);
            formikActions.resetForm();
            props.fetchData();
        }
    };

    return (
        <div className="ms-Grid" dir="ltr">
            {!props.settings && <KendoLoading />}
            {props.settings && (
                <formik.Formik
                    validationSchema={validationSchema}
                    initialValues={{ ...props.settings }}
                    onSubmit={handleSubmit}
                    render={(formikProps) => (
                        <formik.Form>
                            <div className="ms-Grid-row">
                                <div style={{ textAlign: 'center', padding: '10px' }} className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                                    <fabric.Text style={{ fontWeight: 'lighter' }} variant="xLarge">
                                        Skolų funkcijos valdymas
                                    </fabric.Text>
                                </div>
                            </div>

                            <div className="ms-Grid-row">
                                <formik.Field
                                    name="isDeptManagemenetEnabled"
                                    render={({ field, form }: formik.FieldProps<boolean>) => (
                                        <fabric.Toggle
                                            {...field}
                                            styles={{ root: { paddingLeft: '15px' } }}
                                            label="Įjungti/išjungti skolų valdymo funkciją"
                                            inlineLabel
                                            defaultChecked={field.value}
                                            onChange={() => form.setFieldValue(field.name, !field.value)}
                                            onText="Įjungta"
                                            offText="Išjungta"
                                        />
                                    )}
                                />
                            </div>
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg6">
                                    <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg6">
                                        <formik.Field
                                            name="deptAppliesFromValue"
                                            render={({ field, form }: formik.FieldProps<string>) => (
                                                <fabric.TextField
                                                    disabled={form.values.isDeptManagemenetEnabled === false}
                                                    onChange={({}, value: any) => form.setFieldValue(field.name, value)}
                                                    defaultValue={props.settings!.deptAppliesFromValue.toString()}
                                                    type="number"
                                                    errorMessage={
                                                        (formikProps.status && formikProps.status.deptAppliesFromValue) ||
                                                        (form.errors.deptAppliesFromValue && form.errors.deptAppliesFromValue)
                                                    }
                                                    prefix="Skola taikoma nuo"
                                                    suffix="€"
                                                />
                                            )}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="ms-Grid-row">
                                <div style={{ textAlign: 'center', marginTop: '30px' }}>
                                    <fabric.PrimaryButton
                                        className="ms-slideRightIn40 ms-textAlignRight"
                                        text="Išsaugoti"
                                        disabled={formikProps.isSubmitting || !formikProps.isValid || !formikProps.dirty}
                                        type="submit"
                                    />
                                </div>
                            </div>
                        </formik.Form>
                    )}
                />
            )}
        </div>
    );
};

export default GeneralSettingsDebts;
